import styled from 'styled-components';

import { fonts } from '../../../../styles/constants';

export const ProChangePasswordSuccessMessageBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 4px 17px -3px rgba(43, 43, 43, 0.15);
  background-color: #fff;
  padding: 40px 28px 28px 28px;
  border-radius: 8px;
`;

export const ProChangePasswordSuccessMessageBlockTitle = styled.div`
  margin-bottom: 12px;
`;

export const ProChangePasswordSuccessMessageBlockSubTitle = styled.div`
  margin-bottom: 40px;
`;
